import { useMemo } from "react";

import { extractGroupValues } from "../../state/util";
import { State } from "../../types";

export const useExtractGroupValues = (
  groupKey: string,
  groupMultiple: boolean,
  taxonomy: State["taxonomy"],
  values: State["values"],
) =>
  useMemo(() => extractGroupValues(groupKey, groupMultiple, taxonomy, Object.keys(values)), [
    groupKey,
    groupMultiple,
    taxonomy,
    values,
  ]);
